import { gridFluid41Cls, gridFluid41ItemMaxWidthXs, gridFluid41ItemMaxWidthSm, gridFluid41ItemMaxWidthMd, gridFluid41ItemMaxWidthLg, gridFluid41ItemMaxWidthXl, gridFluid41HorizontalGutterXs, gridFluid41HorizontalGutterSm, gridFluid41HorizontalGutterMd, gridFluid41HorizontalGutterLg, gridFluid41HorizontalGutterXl, gridFluid21Cls, gridFluid21ItemMaxWidthXs, gridFluid21ItemMaxWidthSm, gridFluid21ItemMaxWidthMd, gridFluid21ItemMaxWidthLg, gridFluid21ItemMaxWidthXl, gridFluid21HorizontalGutterXs, gridFluid21HorizontalGutterSm, gridFluid21HorizontalGutterMd, gridFluid21HorizontalGutterLg, gridFluid21HorizontalGutterXl } from "./Grid.less";
var SETTINGS = {
  2: {
    styles: {
      1: {
        grid: {
          className: gridFluid21Cls
        },
        col: {
          xs: 24,
          sm: 24,
          md: 12,
          lg: 12,
          xl: 12
        },
        dimensions: {
          xs: {
            itemMaxWidth: parseInt(gridFluid21ItemMaxWidthXs, 10),
            horizontalGutter: parseInt(gridFluid21HorizontalGutterXs, 10)
          },
          sm: {
            itemMaxWidth: parseInt(gridFluid21ItemMaxWidthSm, 10),
            horizontalGutter: parseInt(gridFluid21HorizontalGutterSm, 10)
          },
          md: {
            itemMaxWidth: parseInt(gridFluid21ItemMaxWidthMd, 10),
            horizontalGutter: parseInt(gridFluid21HorizontalGutterMd, 10)
          },
          lg: {
            itemMaxWidth: parseInt(gridFluid21ItemMaxWidthLg, 10),
            horizontalGutter: parseInt(gridFluid21HorizontalGutterLg, 10)
          },
          xl: {
            itemMaxWidth: parseInt(gridFluid21ItemMaxWidthXl, 10),
            horizontalGutter: parseInt(gridFluid21HorizontalGutterXl, 10)
          }
        }
      }
    }
  },
  4: {
    styles: {
      1: {
        grid: {
          className: gridFluid41Cls
        },
        col: {
          xs: 24,
          sm: 12,
          md: 8,
          lg: 8,
          xl: 6
        },
        dimensions: {
          xs: {
            itemMaxWidth: parseInt(gridFluid41ItemMaxWidthXs, 10),
            horizontalGutter: parseInt(gridFluid41HorizontalGutterXs, 10)
          },
          sm: {
            itemMaxWidth: parseInt(gridFluid41ItemMaxWidthSm, 10),
            horizontalGutter: parseInt(gridFluid41HorizontalGutterSm, 10)
          },
          md: {
            itemMaxWidth: parseInt(gridFluid41ItemMaxWidthMd, 10),
            horizontalGutter: parseInt(gridFluid41HorizontalGutterMd, 10)
          },
          lg: {
            itemMaxWidth: parseInt(gridFluid41ItemMaxWidthLg, 10),
            horizontalGutter: parseInt(gridFluid41HorizontalGutterLg, 10)
          },
          xl: {
            itemMaxWidth: parseInt(gridFluid41ItemMaxWidthXl, 10),
            horizontalGutter: parseInt(gridFluid41HorizontalGutterXl, 10)
          }
        }
      }
    }
  }
};
export {
  SETTINGS
};
